import { Button, Card, Col, Row } from 'antd';
import { StyleSheet } from "../../../StyleSheet";
import { Key, useState } from 'react';
import { ResponseChannel, ResponseChannelCategoria } from '../../../types/common';
import { DownOutlined, LeftOutlined, UpOutlined } from '@ant-design/icons';
import InfoCardComponent from '../../../components/InfoCardComponent';

interface Props {
    channelData: ResponseChannel | null;
    goBackBtn: Function;
};

const ListItemAccordionChannel = (props: Props) => {
    const { channelData, goBackBtn } = props;
    const [showElement, setShowElement] = useState<Key>();
    const messageInfo = "Si no cuentas con alguno de nuestros canales y te gustaría obtenerlo, comunícate con uno de nuestros asesores al 33 9690 1234"
    const handlePress = (key: Key) => {
        setShowElement(key === showElement ? "" : key);
    };

    return (
        <>
            <InfoCardComponent
                title="¿No cuentas con alguno de nuestros canales?"
                description={messageInfo}
            />
            <div style={styles.mainContainer}>
                <div style={{ justifyContent: 'flex-end', display: 'flex', marginBottom: 20 }}>
                    <Button style={styles.buttonPrimary} type="primary"
                        onClick={() => goBackBtn()}>
                        <LeftOutlined />
                        {"Regresar"}
                    </Button>
                </div>
                {channelData?.categorias.map((item: ResponseChannelCategoria, index) => (
                    <Card key={index} style={styles.cardStyles}>
                        <Row style={{ cursor: 'pointer' }} onClick={() => handlePress(index)}>
                            <Col style={styles.titleContainer}>
                                <h3 style={{ color: "#757982" }}>{item.categoria}</h3>
                            </Col>
                            <Col style={styles.iconContainer}>
                                {(index === showElement) ? (
                                    <UpOutlined style={styles.iconStyles} />
                                ) : (
                                    <DownOutlined style={styles.iconStyles} />
                                )}
                            </Col>
                        </Row>
                        {(index === showElement) && (
                            <Row gutter={[16, 16]} style={{ marginTop: 30 }}>
                                {item.canales.map((item, index: number) => (
                                    <Col xs={8} md={6} xl={4} key={index} style={{ marginBottom: 10, marginTop: 10, alignContent: 'center' }}>
                                        <img
                                            src={`https://www.megacable.com.mx/images/canales/thumbs/${item.imagen}`}
                                            alt={item.nombre}
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                objectFit: "contain",
                                                display: "block",
                                                margin: "0 auto"
                                            }}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        )}
                    </Card>
                ))}
            </div>
        </>
    );
};

const styles = StyleSheet.create({
    mainContainer: {
        marginTop: 20
    },
    cardStyles: {
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 15
    },
    titleContainer: {
        flex: 1,
        display: "flex",
        height: "100%",
        alignItems: "center",
    },
    iconContainer: {
        display: "flex",
        width: 50,
        height: 50,
        alignItems: "center",
        justifyContent: "center",
    },
    iconStyles: {
        fontSize: 20,
    },
    buttonPrimary: {
        backgroundColor: '#1A1E25',
        borderRadius: 30,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        padding: "20px 20px",
        fontSize: 16
    },
});

export default ListItemAccordionChannel;
